import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { assetRoutes } from './assets-tracking.routes';
import { CommonCloudStudioModule } from 'common-cloudstudio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AssetTrackingComponent } from './asset-tracking.component';
import { TabsContainerModule } from './tabs-container/tabs-container.module';
import { AgmCoreModule } from '@agm/core';
import { RouterModule } from '@angular/router';
import { SharedAssetTrackingComponent } from './shared-asset-tracking/shared-asset-tracking.component';

@NgModule({
  declarations: [
    AssetTrackingComponent,
    SharedAssetTrackingComponent
  ],
  imports: [
    CommonModule,
    CommonCloudStudioModule,
    RouterModule.forChild([
      { path: '', component: AssetTrackingComponent },
    ]),
    ReactiveFormsModule,
    FormsModule,
    AgmCoreModule,
    TooltipModule.forRoot(),
    TabsContainerModule.forRoot(),
  ]
})
export class AssetTrackingModule { }
